export default "__VITE_ASSET__CipUERbZ__"